import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-lock-check",
  "use": "icon-lock-check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"icon-lock-check\">\n  <path d=\"M12.5 21H6a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2.5\" />\n  <path d=\"M8 11V7a4 4 0 1 1 8 0v4\" />\n  <path d=\"M15 19l2 2 4-4\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol